var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"eds-file-icon",attrs:{"src":`imgs/svg/eds/${_vm.fileIcon}`,"width":`${_vm.width}px`,"height":`${_vm.height}px`}})
}
var staticRenderFns = []

export { render, staticRenderFns }